import { useEffect, useState } from 'react';
import { useTranslation } from '@frontend/i18n';
import {
  ContentLoader,
  Modal,
  ModalControlModalProps,
  Text,
  TextareaField,
  useControlledField,
} from '@frontend/design-system';

type Props = {
  disableCloseOnOverlayClick?: boolean;
  isLoading?: boolean;
  modalProps: ModalControlModalProps;
  onSubmit: (message: string) => void;
  showAllowToContact?: boolean;
  subtitle?: string;
  title?: string;
  trackingIdBase?: string;
  isAIFeedback?: boolean;
  isAIPositiveFeedback?: boolean;
};

export const GeneralFeedbackModal = ({
  disableCloseOnOverlayClick,
  isLoading,
  modalProps,
  onSubmit,
  subtitle,
  title,
}: Props) => {
  const { t } = useTranslation('analytics');

  const [message, setMessage] = useState<string>();

  const messageField = useControlledField({
    onChange: setMessage,
    type: 'text',
    value: message,
  });

  const handleSubmit = () => {
    if (!message) return;
    onSubmit(message);
  };

  useEffect(() => {
    if (!modalProps.show) {
      setMessage(undefined);
    }
  }, [modalProps.show]);

  return (
    <Modal
      {...modalProps}
      disableCloseOnEscape={isLoading}
      disableCloseOnOverlayClick={disableCloseOnOverlayClick || isLoading}
      maxWidth={600}
    >
      <Modal.Header onClose={modalProps.onClose}>
        {title || t('Share Feedback or Report an Issue in Analytics')}
      </Modal.Header>
      <Modal.Body>
        <Text>
          {subtitle ||
            t(
              'Please describe the issue or suggestion in detail. Specific details like (what is expected vs what is available in analytics) will help us move fast'
            )}
        </Text>
        <TextareaField {...messageField} label={t('Feedback')} name='product-feedback' />
      </Modal.Body>
      <Modal.Actions
        disablePrimary={!message}
        onPrimaryClick={handleSubmit}
        onSecondaryClick={modalProps.onClose}
        primaryLabel={t('Submit')}
        secondaryLabel={t('Cancel')}
      />
      <ContentLoader show={isLoading} />
    </Modal>
  );
};
